import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export default function SignupPage() {
  const [firstName, setFirstName] = useState('');
  const [lastName,  setLastName ] = useState('');
  const [email,     setEmail    ] = useState('');
  const [password,  setPassword ] = useState('');
  const [loading,   setLoading  ] = useState(false);
  const [error,     setError    ] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const redirectUrl = `${window.location.origin}/auth/signin`;
    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: { first_name: firstName, last_name: lastName },
        emailRedirectTo: redirectUrl
      }
    });

    setLoading(false);
    if (error) { setError(error.message); return; }
    window.location.href = '/auth/signin';
  }

  async function signInWithGoogle() {
    setLoading(true);
    setError(null);
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: `${window.location.origin}/library` }
    });
    if (error) { setError(error.message); setLoading(false); }
  }

  return (
    <div className="relative min-h-screen flex items-center justify-center p-6 overflow-hidden">
      {/* --- Background (mesh-style radial gradients) --- */}
      {/* --- Background is now global in App.tsx --- */}

      {/* --- Glass card --- */}
      <div className="rounded-2xl p-[2px] bg-white/30">
        <div className="rounded-2xl w-[min(92vw,420px)] p-6 sm:p-8
                        bg-white/10 dark:bg-white/10
                        backdrop-blur-xl
                        border border-white/20
                        shadow-2xl">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-9 h-9 rounded-lg bg-white/15 border border-white/20 flex items-center justify-center">
              <div className="w-6 h-6 rounded-lg overflow-hidden">
                <img
                  src="/lovable-uploads/obyect_new.svg"
                  alt="Obyect Logo"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
            <h1 className="text-2xl font-semibold text-black drop-shadow-sm">Sign up</h1>
          </div>
          <p className="text-sm text-black/80 mb-4">Welcome to Obyect 👋</p>

          <form onSubmit={onSubmit} className="grid gap-3">
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="text-sm font-medium text-black/90">First Name *</label>
                <input
                  className="mt-1 w-full rounded-md border border-black/15 bg-white/5
                             px-3 py-2 text-sm text-black placeholder-black/60
                             outline-none focus:ring-2 focus:ring-white/40"
                  placeholder="Jane"
                  value={firstName}
                  onChange={(e)=>setFirstName(e.target.value)}
                  required
                />
              </div>
              <div>
                <label className="text-sm font-medium text-black/90">Last Name *</label>
                <input
                  className="mt-1 w-full rounded-md border border-black/15 bg-white/5
                             px-3 py-2 text-sm text-black placeholder-black/60
                             outline-none focus:ring-2 focus:ring-white/40"
                  placeholder="Doe"
                  value={lastName}
                  onChange={(e)=>setLastName(e.target.value)}
                  required
                />
              </div>
            </div>

            <div>
              <label className="text-sm font-medium text-black/90">Email Address *</label>
              <input
                type="email"
                className="mt-1 w-full rounded-md border border-black/15 bg-white/5
                           px-3 py-2 text-sm text-black placeholder-black/60
                           outline-none focus:ring-2 focus:ring-white/40"
                placeholder="janedoe@example.com"
                value={email}
                onChange={(e)=>setEmail(e.target.value)}
                required
              />
            </div>

            <div>
              <label className="text-sm font-medium text-black/90">Password *</label>
              <input
                type="password"
                className="mt-1 w-full rounded-md border border-black/15 bg-white/5
                           px-3 py-2 text-sm text-black placeholder-black/60
                           outline-none focus:ring-2 focus:ring-white/40"
                placeholder="Choose a strong password"
                value={password}
                onChange={(e)=>setPassword(e.target.value)}
                required
              />
            </div>

            <label className="flex items-start gap-2 text-xs text-black/80 mt-1">
              <input type="checkbox" required className="mt-0.5" />
              <span>
                By signing up you agree to our <a className="underline" href="/terms">Terms of Service</a>.
              </span>
            </label>

            {error && <p className="text-sm text-red-200">{error}</p>}

            <button
              type="submit"
              disabled={loading}
              className="mt-1 h-11 rounded-md
                         bg-black/90 text-white font-medium
                         hover:bg-black transition-colors
                         disabled:opacity-60"
            >
              {loading ? 'Creating…' : 'Sign Up'}
            </button>

            <div className="my-2 flex items-center gap-3 text-xs text-black/70">
              <span className="flex-1 h-px bg-black/25" />
              <span>OR</span>
              <span className="flex-1 h-px bg-black/25" />
            </div>

            <button
              type="button"
              onClick={signInWithGoogle}
              disabled={loading}
              className="h-11 rounded-md border border-black/15 bg-white/15
                         font-medium flex items-center justify-center gap-2
                         text-black hover:bg-black/10 transition-colors disabled:opacity-60"
            >
              <img src="https://www.svgrepo.com/show/475656/google-color.svg" className="w-5 h-5" alt="Google" />
              Sign Up with Google
            </button>

            <p className="text-sm text-center mt-2 text-black/80">
              Already have an account? <a className="underline" href="/auth/signin">Sign In</a>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}
